import React, { useState } from 'react'
import Toast from 'react-bootstrap/Toast'
import PropTypes from 'prop-types'
import { ToastContainer } from 'react-bootstrap'
import './snackbar.css'

function DisplayToast(props) {
  const {text, title, type} = props
  const [showA, setShowA] = useState(true)

  const toggleShowA = () => setShowA(!showA)

  return (    
    <ToastContainer containerPosition="fixed" position="top-end" className="p-3 z-index-5">
      <Toast 
        className="d-inline-block m-1 z-index1000" 
        bg='danger'
        show={showA} 
        onClose={toggleShowA} 
        animation={true} 
        >
          <Toast.Header>
            {type == 'error' ? 
              <i className="fa-solid fa-circle text-danger"></i> 
              : 
              <i className="fa-solid fa-circle text-success"></i>
            }
            <strong className="me-auto text-danger">{title}</strong>
          </Toast.Header>
          <Toast.Body className='text-white'>{text}</Toast.Body>
        </Toast>
    </ToastContainer>
     
  )
}

DisplayToast.propTypes = {
	text: PropTypes.string, 
    title: PropTypes.string, 
    type: PropTypes.string
}

DisplayToast.defaulProps = {
	text: undefined, 
    title: undefined, 
    type: undefined
}

export default DisplayToast